<template>
  <div>
    <el-dialog title="" :visible.sync="dialogFormVisible">
      <el-form>
        <el-form-item label="分类名称" :label-width="formLabelWidth">
          <el-input v-model="className" auto-complete="off" :maxlength="15"></el-input>
        </el-form-item>
        <el-form-item label="排序(值大排前)" :label-width="formLabelWidth">
          <el-input v-model="classSort" auto-complete="off" :maxlength="3"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCreateClass">取 消</el-button>
        <el-button type="primary" @click="qdCreateClass">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <span>删除分类后将无法恢复，确定删除？</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="classDeleteOK">确 定</el-button>
  </span>
    </el-dialog>
    <el-container>
      <el-header>
        <div style="margin: 20px 0">
          <el-button type="primary" @click="openCreateClass(1)" size="small">创建分类</el-button>
          <el-button type="warning" @click="openCreateClass(3)" size="small">修改分类</el-button>
          <el-button type="danger" @click="openCreateClass(2)" size="small">删除分类</el-button>
        </div>
      </el-header>
      <el-main>
        选中：<span v-html="isName"></span><br/>
        <el-tree :data="data" :props="defaultProps" @current-change="handleNodeClick"></el-tree>
      </el-main>
    </el-container>
  </div>
</template>
<script>
  export default {
    name: 'class',
    data() {
      return {
        centerDialogVisible: false,
        dialogFormVisible:false,
        isType:0,
        isLevel:1,
        isSort:0,
        isId:'',
        isName:'',
        formLabelWidth: '120px',
        className:"",
        classSort:0,
        data: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        }
      }
    },
    methods: {
      classDeleteOK:function () {
        if(this.isId == ""){
          this.$message({
            message: "请选择分类",
            type: 'warning'
          });
          return false;
        }else{
          this.isType = 2;
          this.qdCreateClass();
          this.centerDialogVisible = false
        }
      },
      openCreateClass:function (val) {
        if(val == 3){
          if(this.isId == ""){
            this.$message({
              message: '请选择分类',
              type: 'warning'
            });
          }else{
            this.className = this.isName;
            this.classSort = this.isSort;
            this.dialogFormVisible = true;
            this.isType = val;
          }
        }else if(val == 1){
          this.isName = "";
          this.isLevel = 1;
          this.isSort = "";
          this.isId = "";
          this.className = "";
          this.classSort = 0;
          this.dialogFormVisible = true;
          this.isType = val;
        }else if(val == 2){
          if(this.isId == ""){
            this.$message({
              message: '请选择分类',
              type: 'warning'
            });
          }else{
            this.centerDialogVisible = true;
          }
        }
      },
      closeCreateClass:function () {
        this.className = "";
        this.classSort = 0;
        this.dialogFormVisible = false;
      },
      deleteClass:function () {

      },
      qdCreateClass:async function () {
        if(this.isType == 1){
          if(this.className == ""){
            this.$message({
              message: '请输入分类名称',
              type: 'warning'
            });
            return false;
          }
        }
        if(this.isType == 3){
          if(this.className == ""){
            this.$message({
              message: '请输入要修改分类名称',
              type: 'warning'
            });
            return false;
          }
        }
        var _this = this;
        await this.$axios.post('/root/classMessage',{
            "t":this.isType,
            "s":this.classSort,
            "l":this.isLevel,
            "id":this.isId,
            "n":this.className
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.$message({
              message: response.message,
              type: 'success'
            });
            this.addClass();

          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message.error('操作异常');
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
        this.isLevel = 1;
        this.isSort = "";
        this.isId = "";
        this.className = "";
        this.classSort = 0;
        this.dialogFormVisible = false;
      },
      addClass:async function(){
        await this.$axios.post('/data/addClass',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.data = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      handleNodeClick(data,checked,indeterminate) {
        this.isLevel = data.level;
        this.isSort = data.sort;
        this.isName = data.label;
        this.isId = data._id;
      }
    },
    mounted:function () {
      this.addClass();
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/addUser/class.vue